export default {
  dataIterator: {
    rowsPerPageText: 'Sayfa başına satır:',
    rowsPerPageAll: 'Hepsi',
    pageText: '{0}-{1} de {2}',
    noResultsText: 'Eşleşen Veri Bulunamadı',
    nextPage: 'Sonraki sayfa',
    prevPage: 'Önceki sayfa'
  },
  dataTable: {
    rowsPerPageText: 'Sayfa başına satır:'
  },
  noDataText: 'Uygun veri yok',
  carousel: {
    prev: 'Önceki görsel',
    next: 'Sonraki görsel'
  }
}
